import React, { FC } from 'react';
import { useTheme } from '../../../../../../../theme';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { TurnButton } from '../../../../../../../BaseComponents';
import { UpgradeOption } from '../../../../../../../DesktopFlight/types';
import { CdnIcon, SafeHtml } from '@shared/ui';
import { useFareOverrides } from '../../../../model/useFareOverrides';
import { FareGroupUpgradeVariant } from '../../../../model/types';

interface Props {
	className?: string;
	variant?: FareGroupUpgradeVariant;
	upgradeOption?: UpgradeOption;
	fareFamilyId?: string;
	onUpgrade?: () => void;
}

const Upgrade: FC<Props> = ({ className, variant = 'upgrade', fareFamilyId, upgradeOption, onUpgrade }) => {
	const { Upgrade: css } = useTheme('Entities').FareGroupV2;
	const { t } = useTranslation('FareGroup');

	const { renderFareOptionsTypeIcon } = useFareOverrides();

	const isUpgrade = variant === 'upgrade';
	const isSubscribe = variant === 'subscribe';
	const nextFareTitle = upgradeOption?.canUpgradeTo?.fareFamily?.title;

	const upgradeText = t(`Upgrade_${fareFamilyId}`, {
		defaultValue: t('Upgrade')
	});

	if (!upgradeText) {
		return null;
	}

	const showUpgradeOffer = !!upgradeOption?.upgradeOffer;
	const showNextFareTitle = isUpgrade && !!nextFareTitle;

	return (
		<div className={cn(css.root, className, css[variant])} onClick={onUpgrade}>
			<div className={css.header}>
				{showUpgradeOffer && <SafeHtml tag="span" className={css.text} html={upgradeOption?.upgradeOffer} />}

				{showNextFareTitle && (
					<span className={css.text}>
						{upgradeText} {nextFareTitle}
					</span>
				)}
			</div>

			<div className={css.footer}>
				<div className={css.icons}>
					{isUpgrade && (
						<div key={'Action/Add'} className={css.icon}>
							<CdnIcon icon="Action/Add" />
						</div>
					)}

					{upgradeOption?.optionsAvailableOnNextFare.length > 0 &&
						upgradeOption?.optionsAvailableOnNextFare.map((type, index) => (
							<div key={index} className={css.icon}>
								{renderFareOptionsTypeIcon(type)}
							</div>
						))}
				</div>

				<div className={css.buttonWrapper}>
					{isSubscribe && <span className={css.text}>{t('View options')}</span>}
					<TurnButton className={css.button} />
				</div>
			</div>
		</div>
	);
};

export default Upgrade;
